interface HTMLBpmnProps {
	svg?: string;
	src?: string;
	title?: string;
	width?: string;
	height?: string;
}

/** Картинкой, а не разметкой: статический HTML ничего не приносит в чужой документ. */
const HTMLBpmn = ({ svg, title, width, height }: HTMLBpmnProps) => {
	if (!svg) return <div data-component="bpmn" data-unsupported="true" />;

	const source = `data:image/svg+xml;base64,${Buffer.from(svg, "utf8").toString("base64")}`;

	// Размер приходит строкой `620px`, а атрибуты `width`/`height` принимают целое без единиц.
	return (
		<figure data-component="bpmn">
			<img alt={title ?? ""} src={source} style={{ maxWidth: "100%", width, height }} />
			{title && <figcaption>{title}</figcaption>}
		</figure>
	);
};

export default HTMLBpmn;
